export default __webpack_public_path__ + "static/media/P9.9b4f2997.png";